import {css} from 'lit';
export const styles = css`:host{width:100%;--bl-button-display:block;--bl-button-justify:start}`;
export default styles;
